/**
 * 分期收款共用的標籤與小工具。
 *
 * 分期收款頁、顧客資料頁、結帳頁都會用到同一組文字 ——
 * 抽出來放一份，避免三個地方各寫一次、日後改了一處漏了另一處。
 */

export const INSTALLMENT_METHOD_LABEL = {
  cash: '現金',
  transfer: '匯款',
  cardPayment: '刷卡',
  mobilePayment: '行動支付',
  storedValue: '儲值金扣款'
}

export const INSTALLMENT_FREQUENCY_LABEL = {
  monthly: '每月一期',
  biweekly: '每兩週一期',
  weekly: '每週一期',
  per_visit: '每次來店繳'
}

export const installmentMoney = (v) =>
  `NT$ ${Math.round(Number(v) || 0).toLocaleString()}`

/** 還沒收完、也沒有減免的期數 */
export const pendingPeriods = (plan) =>
  (plan?.schedule || []).filter(
    (s) => s.status !== 'paid' && s.status !== 'waived'
  )

/**
 * 開收款視窗時預設要收多少：
 *   有「這次該收」（已到期／每次來店繳）就帶那個數字，
 *   否則帶下一期，再不然就是全部未收。
 */
export const defaultPayAmount = (plan) =>
  plan?.dueNowAmount || plan?.nextDueAmount || plan?.outstanding || 0
